"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = exports.getPaymentInitiateData = exports.getPaymentAuthorizeData = exports.getFullAuthorizeData = exports.fetchAddressInfo = exports.constructPostValidateResponse = void 0;
var _commonUtils = require("../../../utils/commonUtils");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Prepare initiate payment data as payload for APPLEPAY transaction
 *
 * @param data: Raw Payment method
 * @returns {Object}: Prepare object with payment data to be used in payload
 */
var getPaymentInitiateData = function getPaymentInitiateData(data, paymentMethod) {
  return {
    paymentMethod: paymentMethod,
    validationURL: data
  };
};

/**
 * Prepare authorize payment data as payload for APPLEPAY transaction
 *
 * @param data: Raw APPLEPAY state data with checkoutId
 * @returns {Object}: Prepare object with payment data to be used in payload
 */
exports.getPaymentInitiateData = getPaymentInitiateData;
var getPaymentAuthorizeData = function getPaymentAuthorizeData(paymentMethod, data) {
  return {
    paymentMethod: paymentMethod,
    payload: {
      payload: JSON.stringify(_objectSpread({}, data))
    }
  };
};
exports.getPaymentAuthorizeData = getPaymentAuthorizeData;
var getFullAuthorizeData = function getFullAuthorizeData(cartAmount, rmsId, inputCustomData, payment, billingAddress, userInfo) {
  var obj = {
    caseId: inputCustomData.caseId,
    cartAmount: cartAmount,
    currencyCode: inputCustomData.cart.currencyCode,
    billingAddress: billingAddress,
    user: getUserInfo(userInfo),
    payment: payment,
    sessionIds: rmsId && {
      RMS: rmsId
    }
  };
  Object.keys(obj).forEach(function (key) {
    return (obj[key] == undefined || obj[key] == null) && delete obj[key];
  });
  return obj;
};
exports.getFullAuthorizeData = getFullAuthorizeData;
var getUserInfo = function getUserInfo(userInfo) {
  var _checkEmptyNullUndefi;
  return {
    firstName: (0, _commonUtils.checkEmptyNullUndefined)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.givenName),
    lastName: (_checkEmptyNullUndefi = (0, _commonUtils.checkEmptyNullUndefined)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.familyName)) !== null && _checkEmptyNullUndefi !== void 0 ? _checkEmptyNullUndefi : 'LNU',
    emailAddress: (0, _commonUtils.trimEmail)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailAddress),
    phoneNumber: (0, _commonUtils.checkEmptyNullUndefined)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.phoneNumber)
  };
};
exports.getUserInfo = getUserInfo;
var fetchAddressInfo = function fetchAddressInfo(billingFields, userInfo) {
  var _checkEmptyNullUndefi2, _billingFields$addres;
  return {
    firstName: (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.givenName),
    lastName: (_checkEmptyNullUndefi2 = (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.familyName)) !== null && _checkEmptyNullUndefi2 !== void 0 ? _checkEmptyNullUndefi2 : 'LNU',
    addressLine1: billingFields.addressLines && (billingFields === null || billingFields === void 0 ? void 0 : billingFields.addressLines[0]),
    addressLine2: (billingFields === null || billingFields === void 0 || (_billingFields$addres = billingFields.addressLines) === null || _billingFields$addres === void 0 ? void 0 : _billingFields$addres.length) == 2 ? billingFields === null || billingFields === void 0 ? void 0 : billingFields.addressLines[1] : undefined,
    city: (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.locality),
    stateOrProvince: (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.administrativeArea),
    postalCode: (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.postalCode),
    countryCode: (0, _commonUtils.checkEmptyNullUndefined)(billingFields === null || billingFields === void 0 ? void 0 : billingFields.countryCode),
    emailAddress: (0, _commonUtils.trimEmail)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailAddress),
    phoneNumber: (0, _commonUtils.checkEmptyNullUndefined)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.phoneNumber)
  };
};
exports.fetchAddressInfo = fetchAddressInfo;
var constructPostValidateResponse = function constructPostValidateResponse(customFunctions, billingAddress, userInfo, paymentMethod) {
  return customFunctions['postValidate'] ? customFunctions['postValidate']({
    paymentData: {
      paymentMethod: paymentMethod
    },
    otherInformation: _objectSpread(_objectSpread({}, billingAddress), {}, {
      phoneNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.phoneNumber
    }),
    userInformation: userInfo
  }) : {};
};
exports.constructPostValidateResponse = constructPostValidateResponse;